import Vue from 'vue';

const success = (context, response) => {
  context.invoice = response.invoice;
  context.invoice.email = JSON.parse(response.invoice.email);
  context.settings = response.settings;
};

const failed = (context, error) => {
};

export default (ownerId, year, month, context) => {
  return Vue.$http.get(`superconciergerie/invoice/${ownerId}/${year}/${month}`)
    .then(response => {
      success(context, response.data);
    }).catch(error => {
      failed(context, error);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/superconciergerie/get-invoice.js